import axios from "../../../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/translation/BatchTranslatePrompt/index", {
        params: {
            ...params
        }
    } )
}
function EDIT_DATA(params) {
    return  axios.post("/translation/BatchTranslatePrompt/edit",
        {id:params}
    )
}
function SUBMIT_ADD(params) {
    return  axios.post("/translation/BatchTranslatePrompt/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/translation/BatchTranslatePrompt/editPost",{...params} )
}


function DELE(params) {
    return  axios.get("/translation/BatchTranslatePrompt/delete",{
        params: {
            ids:params
        }
    } )
}
export default {
    GET_LIST,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    DELE,
}
